<template>
	<div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
			<div class="columns is-multiline is-centered" v-lazy-container="{ selector: 'img' }">
                <div class="column" :class="width" v-for="(article , index) in articles" :key="`article${index}`">
                    <div class="card card-article">
                        <a :href="article.route">
                            <div class="card-image">
                                <figure class="image is-5by3">
                                    <img :data-src="article.image" class="image-cover" :alt="article.title">
                                </figure>
                            </div>
                            <div class="card-content">
                                <div class="content has-text-weight-bold">
                                    <p class="truncate-3-lines has-text-primary">
                                        {{ article.title }}
                                    </p>
                                    <time class="has-text-secondary" datetime="2020-8-22">{{  article.date }}</time>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
			</div>
			<div class="mt-6 has-text-centered content-loader-container" v-show="loadMore">
				<img src="/front/img/illustrations/content_loader.svg" class="content-loader"  alt="">
			</div>
		</div>
	</div>
</template>


<script>
import axios from 'axios';
import infiniteScroll from 'vue-infinite-scroll';
export default {
	name: "Blog",
	directives: {
		infiniteScroll
	},
	props: {
		lang:{
			type: String,
			required: true
		},
		url: String,
		width:{
			type:String,
			default: 'is-4'
		},
		withFilter:{
			type:Boolean,
			default: true
		}
	},
	computed: {
		busy() {
			return this.fetching
		}
	},
	data(){
		return {
			currentPage: 0,
			fetching: true,
			loadMore : true,
			nextUrl : String,
			articles: [],
		};
	},
	created() {
		this.nextUrl = this.url;
		this.articles = [];
		this.loadNextPage();
	},
	mounted() {
		this.$translate.setLang(this.lang);
	},
	methods: {
		loadNextPage() {
			this.currentPage++;
			this.fetching = true;
			if(this.nextUrl != null){
				axios.get(this.nextUrl)
				.then(({ data }) => {
					this.articles.push(...data.data);
					if(data.links.next != null) {
						this.nextUrl = data.links.next;
					} else {
						this.nextUrl = data.links.next;
					}
					this.fetching = false;
				});
			}
			else{
				this.loadMore = false;
			}
		},
	}
}
</script>

<style scoped lang="scss">
</style>
